import clsx from 'clsx';
import { useCashAccounts } from '../../CashAccount';
import { CashAccount } from '../../generated/graphql';
import { CashAccountsTableContainer, CashAccountsTableContainerProps } from './CashAccountsTableContainer';
import { CashAccountSumTableItem } from './CashAccountSumTableItem';

interface PersonalFinancialStatementCashAccountsTableProps
  extends Pick<CashAccountsTableContainerProps, 'tableTitleClassName'> {
  householdID: string;
  onItemClicked?: (a: { cashAccount: CashAccount }) => void;
}

export function PersonalFinancialStatementCashAccountsTable({
  householdID,
  onItemClicked,
  tableTitleClassName,
}: PersonalFinancialStatementCashAccountsTableProps) {
  const { cashAccounts, cashAccountsQuery } = useCashAccounts({ householdID });

  return (
    <CashAccountsTableContainer
      cashAccountArray={Array.from(cashAccounts || [])}
      className="mb-4 md:mb-[47px] last:mb-6"
      tableRowsContainerClassName="mt-[2px]"
      tableTitleClassName={clsx(tableTitleClassName, 'sticky top-[56px] z-[1] bg-darkMode-gray-background')}
      isLoading={cashAccountsQuery.isLoading}
      onItemClicked={onItemClicked}
    >
      {({ cashAccount }) => (
        <CashAccountSumTableItem
          key={cashAccount.id}
          cashAccount={cashAccount}
          onItemClicked={onItemClicked}
          className="focus:shadow-classic"
        />
      )}
    </CashAccountsTableContainer>
  );
}
